<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <logs-index/>
        </v-layout>
    </v-container>
</template>

<script>
    import LogsIndex from "../../../components/admin/Logs/Logs/LogsIndex";
    
    export default  {
        components: {
            LogsIndex,
        }
    }
</script>